import { DecimalPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ModalController, Platform } from "ionic-angular";
import moment from "moment";
import { Observable } from "rxjs/Observable";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";

@Component({
  selector: "time-to-task-list-card",
  templateUrl: "time-to-task-list-card.html",
})
export class TimeToTaskListCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  id: string;
  name: string;
  componentId: string;
  label: string;
  access: string;
  tooltip: object;
  colHeaders: string[];
  conditionalFormatting: object;
  deltaFields: string[];
  rawData: any[] = [];
  dataRows: any[] = [];
  dummyRow: object;
  previousData: any[] = [];
  declinable: boolean;
  editable: boolean = false;
  manualAdd: boolean = true;
  taskOptionsMaster: Array<string> = [];

  allowExternalData: boolean = false;
  delta: {};

  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;

  cardDepObs: Observable<any> = null;

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    private alertCtrl: AlertController,
    public translatePipe: TranslateService,
    public intercard: IntercardDataService
  ) {}

  ngOnInit(): void {
    // console.log("List-card config:", this.config);

    this.id = this.config.id;
    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.conditionalFormatting = this.config.data.conditionalFormatting;
    this.deltaFields = this.config.data.deltaFields || [];
    this.declinable = this.config.declinable;

    if (this.config.editable) {
      this.editable = this.config.editable;
    }
    if (this.config.manualAdd !== undefined && this.config.manualAdd !== null) {
      this.manualAdd = this.config.manualAdd;
    }
    if (this.config.allowExternalData) {
      this.allowExternalData = this.config.allowExternalData;
    }

    this.taskOptionsMaster = this.config.inputs.task.options;

    this.dummyRow = { id: "" };
    let dummyData = {};
    for (let header of this.colHeaders) {
      dummyData[header] = "-";
    }
    this.dummyRow["values"] = dummyData;

    if (this.allowExternalData) {
      this.cardDepObs = this.intercard.register(this.name);
      this.cardDepObs.subscribe((data) => {
        // console.log( "Received emitted data from other card!", data );
        if (data === undefined) {
          return;
        }

        let newData = {};
        for (let header of this.colHeaders) {
          if (data[header]) {
            newData[header] = data[header];
          }
        }

        this.addData(newData);
      });
    }
    this.updateDiffs();
    this.updateDataPages();
  }

  filterPreviousData(rawPreviousData) {
    return rawPreviousData.filter((recordA) => {
      let latestTask = recordA;

      for (let recordB of rawPreviousData) {
        if (recordA !== recordB && recordA.task === recordB.task) {
          let dateA = moment(recordA.createDate);
          let dateB = moment(recordB.createDate);

          if (dateA > dateB) {
            latestTask = recordA;
          } else {
            return false;
          }
        }
      }

      return latestTask === recordA;
    });
  }

  @Input() set data(incomingData: any) {
    // console.log( "Form card Data: ", this.data );
    // console.log( "Form card Incoming data: ", incomingData );
    if (incomingData) {
      // Call some service to load rows and prevRow
      this.dataRows = [];
      this.rawData = incomingData["data"] || [];
      let rawPreviousData = incomingData["history"] || [];
      this.previousData = this.filterPreviousData(rawPreviousData);

      for (let record of this.rawData) {
        let newRow = { id: record.id };
        newRow["values"] = this.parseDataRow(record);
        this.dataRows.push(newRow);
      }

      this.updateDiffs();
      this.updateDataPages();

      // console.log("New ROWS:", this.dataRows);
      // console.log("New PREV:", this.prevRow);
    }
  }

  getPageNumber() {
    return this.currentPage + 1;
  }

  presentListForm(data?: object): void {
    let config = { config: this.config };
    // console.log( "Presenting modal config.", data );
    if (data !== undefined) {
      config["data"] = data;
      // console.log( "Modified config" );
    }

    //update dropdown list
    let filteredOptions = [];
    for (let modalOption of this.taskOptionsMaster) {
      let exists = false;
      for (let existingTask of this.dataRows) {
        if (modalOption === existingTask.values.task) {
          exists = true;
        }
      }
      if (!exists) {
        filteredOptions.push(modalOption);
      }
    }

    config.config.inputs.task.options = filteredOptions;

    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      // console.log( "GOT DATA BACK!:", data );

      if (data !== undefined && data !== null) {
        // check that the 'other' option entered wasn't a duplicate of something in the existing rows
        // if it is, display a warning
        let isDuplicateTask = false;
        for (let row of this.dataRows) {
          if (row.values.task === data.task) {
            isDuplicateTask = true;
          }
        }
        if (!isDuplicateTask) {
          this.addData(data);
        } else {
          let alert = this.alertCtrl.create({
            title: this.translatePipe.instant("duplicateTask"),
            message: this.translatePipe.instant("unableToAddDuplicateTask"),
            buttons: [
              {
                text: "ok",
              },
            ],
          });
          alert.present();
        }
      }

      config.config.inputs.task.options = this.taskOptionsMaster;
    });
    listModal.present();
  }

  enterTimeForExistingTask(data?: object) {
    let config = { config: this.config };
    if (data !== undefined && data["values"] && data["values"]["task"]) {
      config["data"] = { task: data["values"]["task"] };
    }

    config.config.inputs.task.readonly = true;

    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined && data !== null) {
        for (let i = 0; i < this.rawData.length; i++) {
          if (this.rawData[i].task === config["data"]["task"]) {
            this.rawData.splice(i, 1);
            i = 0;
          }
        }
        for (let i = 0; i < this.dataRows.length; i++) {
          if (this.dataRows[i]["values"].task === config["data"]["task"]) {
            this.dataRows.splice(i, 1);
            i = 0;
          }
        }
        this.addData(data);
      }

      config.config.inputs.task.readonly = false;
    });
    listModal.present();
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      flatData[key] = data[key];
    }
    // console.log( "FLATTENED IT: ", flatData );
    return flatData;
  }

  parseDataRow(data: object) {
    let values = {};
    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      // console.log( "Checking header: ", header );
      let val = "-";
      if (flatData[header] || flatData[header] === 0) {
        if (header === "date") {
          flatData[header] = moment(flatData[header]).format(dateTimeFormat);
        }
        if (header === "previousTimeToTask") {
          for (let prev of this.previousData) {
            if (prev.id === header) {
              flatData[header] = prev["timeToTask"] || "-";
            } else {
              flatData[header] = "-";
            }
          }
        }
        if (header === "changeInTimeToTask") {
          if (flatData["timeToTask"] && flatData["previousTimeToTask"]) {
            flatData[header] =
              flatData["timeToTask"] - flatData["previousTimeToTask"];
          }
        }
        val = flatData[header];
      }
      // console.log( "Produced val: ", val );
      values[header] = val;
    }
    return values;
  }

  addData(data: any): void {
    // console.log( "Data being pushed:" , data, this.name );
    if (data) {
      if (this.assessmentId != null) {
        try {
          this.dataService
            .storeRecord(
              this.assessmentId,
              this.sectionId,
              this.id,
              data,
              this.label
            )
            .subscribe((returnData) => {
              console.log("Data returned from submission:", returnData);
              if (!returnData) {
                return;
              }

              let newData = { id: returnData.id };
              newData["values"] = this.parseDataRow(returnData);

              //console.log("Pushing new val.", newData);
              this.rawData.unshift(returnData);
              this.dataRows.unshift(newData);
              this.updateDiffs();
              this.updateDataPages();
            });
        } catch (error) {
          //console.log( "Error during data submission and building.", error );
        }
      }
    }
  }

  updateDiffs() {
    for (let row of this.dataRows) {
      if (this.previousData) {
        for (let prevRow of this.previousData) {
          if (row["values"].task === prevRow.task) {
            row["values"]["previousTimeToTask"] = prevRow.timeToTask || "-";
            if (
              !isNaN(row["values"].timeToTask) &&
              !isNaN(prevRow.timeToTask)
            ) {
              row["values"]["changeInTimeToTask"] =
                row["values"].timeToTask - prevRow.timeToTask;
            }
          }
        }
      }
    }

    if (this.previousData) {
      for (let prevRow of this.previousData) {
        let inData = false;
        for (let row of this.dataRows) {
          if (row["values"].task === prevRow.task) {
            inData = true;
          }
        }
        if (!inData) {
          this.rawData.push(prevRow);
          this.dataRows.push({
            values: {
              task: prevRow.task,
              timeToTask: "-",
              previousTimeToTask: prevRow.timeToTask || "-",
              changeInTimeToTask: "-",
            },
          });
        }
      }
    }
  }

  editRow(row: object): void {
    // console.log( "Editing row: ", row );

    let modalConfig = { config: this.config };
    let values = this.rawData.filter((record) => record.id == row["id"])[0];
    if (values !== null || values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};

      for (let key of inputKeys) {
        if (values[key]) {
          if (key === "issueType") {
            values[key] = this.translatePipe.instant(values[key]);
          }
          editData[key] = values[key];
        } else {
          editData[key] = null;
        }
      }
      modalConfig["data"] = editData;
    }

    //prevent user from modifying the task
    modalConfig.config.inputs.task.readonly = true;

    // console.log( "Launching edit with modal config: ", modalConfig );
    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        this.editData(row, row["id"], data);
      }
      modalConfig.config.inputs.task.readonly = false;
    });
    listModal.present();
  }

  editData(oldRow: object, rowId: string, data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            // console.log( "Data returned from edit:", returnData );

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            //console.log("Pushing new val.", newData);

            let rawData = this.rawData;
            for (let index in rawData) {
              if (rawData[index]["id"] === returnData.id) {
                rawData[index] = returnData;
                break;
              }
            }
            // console.log( "Updated rawData: ", this.rawData );

            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDiffs();
            this.updateDataPages();
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  deleteRow(id: string) {
    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            //console.log( "I'm going to delete: ", id );
            this.dataService
              .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
              .subscribe(() => {
                //console.log( "Removing rows that match: ", id );
                this.rawData = this.rawData.filter((row) => row.id !== id);
                this.dataRows = this.dataRows.filter((row) => row.id !== id);
                this.updateDiffs();
                this.updateDataPages();
              });
          },
        },
      ],
    });
    alert.present();
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }

    if (this.currentPage > dataRows.length % pageSize) {
      this.prevPage();
    }
    // console.log( "Produced pages: ", this.dataPages );
  }

  // ---------- pagination ---------- //

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    if (
      page >= 0 &&
      page <= this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/time-to-task-list-card/time-to-task-list-card.ts